module.exports = __webpack_public_path__ + "img/46e9b5a.jpg";